import React, {  useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import InlineAccountTokenInfo from "./InlineAccountTokenInfo";
import RepayInteractionModal from "../InteractionModal/RepayInteractionModal";
import { useTokenIcon } from "../../hooks/useUrlGenerator";
import DisabledButtonHelper from "../DisabledButtonHelper";
import BorrowInteractionModal from "../InteractionModal/BorrowInteractionModal";
import { useOnchainAccountBorrowable, useOnchainAccountCollateral } from "../../hooks/useOnchain";
import useGenericCall from "../../hooks/useGenericCall";
import { DISABLED_BORROWS } from "../../utils/constants";
import { useNetworkName } from "../../hooks/useNetwork";

export default function AccountLendingPoolBorrowRow() {
  const bData = useGenericCall(useOnchainAccountBorrowable(), async onchainAccountBorrowable => ({
    symbol: await (await onchainAccountBorrowable.getPoolToken().getOffchainPoolToken()).getSymbol(),
    borrowed: await onchainAccountBorrowable.getBorrowed(),
    borrowedUSD: await onchainAccountBorrowable.getBorrowedUSD(),
  }));
  const cData = useGenericCall(useOnchainAccountCollateral(), async onchainAccountCollateral => ({
    symbol: await (await onchainAccountCollateral.getPoolToken().getOffchainPoolToken()).getSymbol(),
    deposited: await onchainAccountCollateral.getDeposited(),
    pairAddress: await (await onchainAccountCollateral.getPoolToken().getOffchainPoolToken()).getUnderlyingAddress(),
  }));

  const tokenIcon = useTokenIcon();
  const network = useNetworkName();

  const [showBorrowModal, toggleBorrowModal] = useState(false);
  const [showRepayModal, toggleRepaywModal] = useState(false);

  if (!cData || !bData) return (null);

  // In case borrowing is intentionally disabled for risky pairs
  const borrowLimitReached = DISABLED_BORROWS[network]?.includes(cData?.pairAddress);

  const borrowDisabledInfo = borrowLimitReached ? 
    `Borrow limit reached. Borrowing is currently disabled for this pair.`
    : `You need to deposit ${cData.symbol} as collateral in order to be able to borrow ${bData.symbol}.`;
  const repayDisabledInfo = `You haven't borrowed any ${bData.symbol} yet.`;

  return (<>
    <Row className="account-lending-pool-row">
      <Col md={3}>
        <Row className="account-lending-pool-name-icon">
          <Col className="token-icon">
            <img className='' src={tokenIcon} />
          </Col>
          <Col className="token-name">
            { `${bData.symbol}` }
          </Col>
        </Row>
      </Col>
      <Col md={4} className="inline-account-token-info-container">
        <InlineAccountTokenInfo
          name="Borrowed"
          symbol={bData.symbol}
          value={bData.borrowed}
          valueUSD={bData.borrowedUSD}
        />
      </Col>
      <Col md={5} className="btn-table">
        <Row>
          <Col>
            { cData.deposited > 0 && !borrowLimitReached ? (
              <Button variant="primary" onClick={() => toggleBorrowModal(true)}>Borrow</Button>
            ) : (
              <DisabledButtonHelper text={borrowDisabledInfo}>Borrow</DisabledButtonHelper>
            ) }
          </Col>
          <Col>
            { bData.borrowed > 0 ? (
              <Button variant="primary" onClick={() => toggleRepaywModal(true)}>Repay</Button>
            ) : (
              <DisabledButtonHelper text={repayDisabledInfo}>Repay</DisabledButtonHelper>
            ) }
          </Col>
        </Row>
      </Col>
    </Row>
    <BorrowInteractionModal 
      show={showBorrowModal} 
      toggleShow={toggleBorrowModal}
    />
    <RepayInteractionModal 
      show={showRepayModal} 
      toggleShow={toggleRepaywModal}
    />
  </>);
}
